import { Injectable } from '@angular/core';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { Observable } from 'rxjs';
import {
  ProductAttributesEntity,
  ProductPriceEntity,
  ProductPricePackEntity,
} from '../configs/entity.config';

@Injectable({
  providedIn: 'root',
})
export class CpvService {
  constructor() {}

  getProductsAttributes(payload: any): Observable<IEntity<any>> {
    const value = {
      ids: payload.mpcUuids,
      keys: ['nameCms'],
    };

    const iEntity = EntityManager.createEntity(ProductAttributesEntity, {});
    iEntity.value = value;
    return EntityManager.saveEntity(iEntity);
  }

  getProductsFiveg(payload: any): Observable<IEntity<any>> {
    const value = {
      ids: payload.mpcUuids,
      keys: ['fiveg'],
    };

    const iEntity = EntityManager.createEntity(ProductAttributesEntity, {});
    iEntity.value = value;
    return EntityManager.saveEntity(iEntity);
  }

  getProductPrice(payload: any): Observable<IEntity<any>> {
    if (payload.packMpcUuid) {
      const value = {
        components: [
          {
            mpcUuid: payload.mpcUuid,
            chargeEvent: payload.chargeConfiguration
              ? payload.chargeConfiguration.event
              : undefined,
            chargeCode: payload.chargeConfiguration
              ? payload.chargeConfiguration.code
              : undefined,
          },
        ],
      };

      const iEntity = EntityManager.createEntity(ProductPricePackEntity, {
        mpcUuid: payload.packMpcUuid,
      });
      iEntity.value = value;
      return EntityManager.saveEntity(iEntity);
    } else {
      return EntityManager.getEntity(ProductPriceEntity, {
        mpcUuid: payload.mpcUuid,
      });
    }
  }
}
